export default "__VITE_PUBLIC_ASSET__2c169f46__"